import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { ProfileCashierButtonCasino777Box } from "./profile-cashier-button.casino777.box";
import { ProfileCashierButtonCasino888Box } from "./profile-cashier-button.casino888.box";
import { ProfileCashierButtonDefaultBox } from "./profile-cashier-button.default.box";
import { ProfileCashierButtonDelawareparkDoverdownsBox } from "./profile-cashier-button.delawareparkdoverdowns.box";
import { ProfileCashierButtonHarringtonBox } from "./profile-cashier-button.harrington.box";
import { ProfileCashierButtonHarrahsWsopBox } from "./profile-cashier-button.harrahswsop.box";

export const ProfileCashierButtonBox = styledByTheme(ProfileCashierButtonDefaultBox)
    .forCasino777(ProfileCashierButtonCasino777Box)
    .forCasino888(ProfileCashierButtonCasino888Box)
    .forDelawarePark(ProfileCashierButtonDelawareparkDoverdownsBox)
    .forDoverDowns(ProfileCashierButtonDelawareparkDoverdownsBox)
    .forHarrington(ProfileCashierButtonHarringtonBox)
    .forHarrahs(ProfileCashierButtonHarrahsWsopBox)
    .forWsop(ProfileCashierButtonHarrahsWsopBox)
    .apply();
